import { useState } from 'react';
import './account-screen.styles.css';
import { axiosInstance } from '@/services/axios.service';
import { ENDPOINTS } from '@/constants/endpoints';
import { useQuery } from '@tanstack/react-query';
import SwitchButton from '@/components/buttons/SwitchButton';
import { X4bUserSettingDto } from './X4bUserSettingDto';
import { copyWith, GenericResponse, ListResponse } from '@/common/common_utils';
import { Table } from '@/components/table/Tables';
import { X4bCompanyAdminDto } from './X4bCompanyAdminDto';
import { Column as PRColumn } from 'primereact/column';
import EmptyTable from '@/components/empty/EmptyTable';
import { showNotification } from '@/modules/notification/engine/notification.library';
import { Column } from '@/components/container/Container';
import { TextLabelLarge2, TextLabelMedium2 } from '@/components/text/Texts';

const SettingsNotificationTab = () => {
	const [adminsFilter, setAdminsFilter] = useState({ skip: 0, take: 5 });
	const admingsQ = useQuery({
		queryKey: ['Account.CompanyAdmins', adminsFilter],
		initialData: { Items: [] as X4bCompanyAdminDto[], TotalRecords: 0 },
		queryFn: async () => {
			const result = await axiosInstance.post<GenericResponse<ListResponse<X4bCompanyAdminDto>>>(ENDPOINTS['/api/X4bUser/GetCompanyAdmins'], {
				Skip: adminsFilter.skip,
				Take: adminsFilter.take
			});
			return result.data.Data;
		}
	});

	return (
		<Column className="gap-6">
			<Column className="gap-4">
				<TextLabelLarge2 className="font-semibold text-primary" text="Receipt Forwarding" />
				<TextLabelMedium2
					className="text-primary"
					text="Email selected admins a copy of receipts when programs are used by employees"
				/>
			</Column>
			<Table
				size="small"
				value={admingsQ.data.Items}
				emptyMessage={EmptyTable({
					title: 'No admins yet',
					description: 'You’ll able to see your admins here.',
					src: '/images/svg/Empty State - No Employees.svg',
				})}
				dataKey="Id"
				paginator={true}
				first={adminsFilter.skip}
				rows={adminsFilter.take}
				lazy
				totalRecords={admingsQ.data.TotalRecords}
				rowsPerPageOptions={[5, 10, 25, 50]}
				onPage={(event) => setAdminsFilter(copyWith(adminsFilter, { skip: event.first }))}
			>
				<PRColumn field="Name" header="Name" />
				<PRColumn field="Email" header="Email" />
				<PRColumn
					field="DoNotify"
					header="Notify?"
					body={(admin: X4bCompanyAdminDto) => (
						<SwitchButton
							checked={!!admin.DoNotify}
							setChecked={async (admin1) => {
								const toPost = {
									UserId: admin.Id,
									DoNotify: !admin.DoNotify
								} as X4bCompanyAdminDto;
								await axiosInstance.post<X4bUserSettingDto>(ENDPOINTS['/api/X4bUser/UpdateUserForwardProgramReceipts'], toPost);
								await admingsQ.refetch();
								showNotification("Company info updated");
							}}
						/>
					)}
				/>
			</Table>
		</Column>





	);
};

export default SettingsNotificationTab;
